<template>
    <v-select v-model="selectedYear" :clearable="false" :multiple="false" :options="yearOptions" label="name"
        name="year" id="year" placeholder="Pilih Tahun" :single="true" @input="handleYearChange" />
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        'v-select': vSelect
    },
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            selectedYear: null,
            yearOptions: []
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    },
    mounted() {
        this.fetchYears();
    },
    methods: {
        async fetchYears() {
            try {
                const response = await axios.get('/api/external-pelayanan/get-year');
                this.yearOptions = response.data || [];
                this.initializeSelectedYear();
            } catch (error) {
                console.error('Error fetching years:', error);
                this.yearOptions = [];
            }
        },
        initializeSelectedYear() {
            const currentYearOption = this.yearOptions.find(y => y.id === this.currentYear);
            this.selectedYear = currentYearOption || this.yearOptions[0] || null;

            if (this.selectedYear) {
                this.$emit('update:modelValue', this.selectedYear.id);
            }
        },
        handleYearChange(selectedOption) {
            this.selectedYear = selectedOption;
            this.$emit('update:modelValue', selectedOption?.id || '');
        }
    },
    watch: {
        modelValue(newVal) {
            if (newVal !== (this.selectedYear?.id || '')) {
                const matchingOption = this.yearOptions.find(y => y.id === newVal);
                this.selectedYear = matchingOption || null;
            }
        }
    }
};
</script>
